import { Component, OnInit } from '@angular/core';
import { profile } from '../../../../data/header';
import { FeatherIconComponent } from "../../../ui/feather-icon/feather-icon.component";
import { Router, RouterModule } from '@angular/router';
import { SimulationStateService } from '../../../../services/simulation-state.service';

@Component({
  selector: 'app-profile',
  imports: [FeatherIconComponent,RouterModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})

export class ProfileComponent implements OnInit {

  public profile = profile;
  public userName = 'AeroVera User';
  public roleName = '';

  constructor(
    public router: Router,
    private simulationState: SimulationStateService
  ) {
  }

  ngOnInit(): void {
    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      this.userName = userData?.UserName?.trim() || 'AeroVera User';
      this.roleName = userData?.RoleName?.trim() || '';
    } catch {
      this.userName = 'AeroVera User';
      this.roleName = '';
    }
  }

   logout(){
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("Subscription");
    localStorage.removeItem("PermissionHierarchy");
    localStorage.removeItem("permissions");
    localStorage.removeItem("selectedFloorId");
    localStorage.removeItem("selectedFacilityId");
    localStorage.removeItem("selectedDevice");
    this.simulationState.clear();
    this.router.navigate(["auth/login"]);
  }
}
